var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.915 494.063c-8.132 8.11-21.348 8.11-29.48 0l-47.908-47.777c-2.137 85.676-36.622 165.945-97.641 226.744-63.026 62.853-146.801 97.451-235.918 97.451-124.019 0-237.144-68-295.139-177.434-5.369-10.138-1.512-22.745 8.68-28.125s22.807-1.508 28.203 8.656c50.749 95.787 149.72 155.287 258.283 155.287 158.009 0 287.137-125.888 291.803-282.345l-47.674 47.543c-8.132 8.11-21.348 8.11-29.48 0s-8.132-21.289 0-29.399l83.409-83.18c4.092-4.081 9.436-6.083 14.753-6.083s10.687 2.028 14.753 6.083l83.409 83.18c8.132 8.11 8.132 21.289 0 29.399h-0.052zM785.427 310.572c-10.166 5.355-22.807 1.508-28.203-8.656-50.749-95.787-149.72-155.287-258.283-155.287-158.009 0-287.137 125.888-291.803 282.345l47.674-47.543c4.092-4.081 9.436-6.083 14.753-6.083s10.687 2.028 14.753 6.083c8.132 8.11 8.132 21.289 0 29.399l-83.409 83.18c-8.132 8.11-21.348 8.11-29.48 0l-83.409-83.18c-8.132-8.11-8.132-21.289 0-29.399s21.348-8.11 29.48 0l47.908 47.777c2.137-85.676 36.622-165.945 97.641-226.744 63.026-62.853 146.801-97.451 235.918-97.451 124.019 0 237.144 68 295.139 177.434 5.369 10.138 1.512 22.745-8.68 28.125v0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.74ed6ddd8b314174451ebc8bccb96834.svg";
export { ForwardRef as ReactComponent };